import { useCallback } from 'react';
import axios from 'axios';
import proxyApi from 'services/proxyApi';
import { BASE_URL, PROXY_API } from 'constants/proxyApi';

const { USER_TELEMETRY } = PROXY_API.POST;

const usePostTelemetryData = (isUserSignedIn: boolean) => {
  const postTelemetryData = useCallback(async (data: any) => {
    try {
      if (isUserSignedIn) {
        await proxyApi.protectedRequest({ url: `${BASE_URL}/${USER_TELEMETRY.LOGIN_TELEMETRY}`, method: 'POST', data });
      } else {
        await axios.post(`${BASE_URL}/${USER_TELEMETRY.TELEMETRY}`, data);
      }
    } catch (error) {
      // No return statement needed
    }
  }, [isUserSignedIn]);

  return postTelemetryData;
};

export default usePostTelemetryData;
